import { takeLatest, put, call, select } from 'redux-saga/effects'
import { HANDLE_PRESENCE_REPORT, SET_PRESENCE, SET_PRESENCE_ON_LESSON_SCREEN } from '../redux/tutorChannelReducer'

function* HandlePresenceReportFlow(action: any): Generator<any, void, any> {
  try {
    if (action.payload.type === 'presence') {
      yield put(SET_PRESENCE(action.payload))
    }
    if (action.payload.type === 'lesson_screen_presence') {
      yield put(SET_PRESENCE_ON_LESSON_SCREEN(action.payload))
    }
  } catch (error) {
    console.log(error)
  }
}

export default function* HandlePresenceReportSaga(): Generator<any, void, any> {
  yield takeLatest([HANDLE_PRESENCE_REPORT], HandlePresenceReportFlow)
}
